// extracted by mini-css-extract-plugin
export var divider = "_h2-7";
export var itemsToggle = "_h2-8";
export var mergeModal = "_h2-1";
export var optionCard = "_h2-4";
export var radioGroup = "_h2-6";
export var radioOption = "_h2-0";
export var selected = "_h2-5";
export var shipmentOptions = "_h2-2";
export var tableOptions = "_h2-3";